import {
  getCustomer,
  putCustomer,
  uploadDocumentAPI,
  addCustomer,
} from "../../utils/apiFunctions";
import {
  dynamicRules,
  getCustomFields,
  columnWidth,
  showError,
  validateField,
} from "../../utils/customFields";
import FormShimmer from "../../components/fixedcomponents/FormShimmer.vue";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import InputField from "../../components/InputComponents/Input";
import CustomQuillEditor from "../../components/InputComponents/CustomQuillEditor";
import SelectCustom from "../../components/InputComponents/SelectCustom";
import MultiSelectCustom from "../../components/InputComponents/MultiSelectCustom";
import SwitchBox from "../../components/InputComponents/Switch";
import UploadDocument from "../../components/InputComponents/UploadDocument";
import FormTags from "../../components/InputComponents/FormTags";
import DateField from "../../components/InputComponents/DateField";
const customerData = {
  name: "customerMixin",
  data: () => ({
    parentID: 2,
    activatelink: false,
    LoaderStatus: false,
    newObject: {
      customFields: {},
    },
    customFieldsArray: [],
    validation: {},
    touchedFields: {},
    valText: {},
    shimmerLoader: false,
  }),
  components: {
    FormShimmer,
    Spinner,
    InputField,
    CustomQuillEditor,
    SelectCustom,
    MultiSelectCustom,
    SwitchBox,
    UploadDocument,
    FormTags,
    DateField,
  },
  async created() {
    this.shimmerLoader = true;
    if (
      this.$route.name == "EditCustomer" ||
      this.$route.name == "ActivateCustomer"
    ) {
      await this.getCustomer();
    } else {
      await this.initializeData("add");
    }
  },
  methods: {
    async initializeData(type) {
      const response = await getCustomFields(this.parentID, type);
      if (response.length) {
        if (type == "add") {
          [this.customFieldsArray, this.newObject, this.touchedFields] =
            response;
        } else {
          [this.customFieldsArray, this.touchedFields] = response;
        }
        this.validations = dynamicRules(this.customFieldsArray);
        this.shimmerLoader = false;
      }
    },
    validateField(field) {
      return validateField(field, this);
    },
    getColumn(field) {
      return columnWidth(field);
    },
    getError(field) {
      return showError(field, this.touchedFields[field.key], this);
    },
    getVmodel(field) {
      return field.fieldType == "default"
        ? this.newObject[field.key]
        : this.newObject.customFields[field.key];
    },
    handleInput(field) {
      this.touchedFields[field.key] = true;
      this.$forceUpdate();
    },
    handleBlur(field) {
      if (this.touchedFields[field.key] && !this.validation[field.key]) {
        this.validateField(field, this);
        this.$forceUpdate();
      }
    },
    updateFieldValue(field, value) {
      if (field.fieldType === "default") {
        this.$set(this.newObject, field.key, value);
      } else {
        this.$set(this.newObject.customFields, field.key, value);
      }
      this.$forceUpdate();
      this.validateField(field, this);
    },
    validateForm() {
      let invalidForm = false;
      for (let i = 0; i < this.customFieldsArray.length; i++) {
        const field = this.customFieldsArray[i];
        this.touchedFields[field.key] = true;
        this.$forceUpdate();
        if (!this.validateField(field, this)) {
          invalidForm = true;
        }
      }
      if (!invalidForm) {
        if (this.$route.name == "AddCustomer") {
          this.addNewCustomer();
        } else {
          this.editCustomer();
        }
      } else {
        this.errorModal("Please fill all details");
      }
    },
    async addNewCustomer() {
      try {
        this.LoaderStatus = true;
        let anotherCust;
        anotherCust = JSON.parse(JSON.stringify(this.newObject));
        for (const field of this.customFieldsArray) {
          if (field.controlType === "upload_file") {
            if (field.fieldType === "default") {
              delete anotherCust[field.key];
            } else {
              delete anotherCust.customFields[field.key];
            }
          }
        }
        let payload = {
          customerType: this.parentID == 2 ? "1" : "2",
          ...anotherCust,
        };
        const res = await addCustomer(payload);
        if (res.status == 200) {
          const form = new FormData();
          form.append("type", this.parentID);
          form.append("customerID", res.data.data.Details);

          var attachment = [];

          // Iterate over custom fields to append data to FormData object
          for (const field of this.customFieldsArray) {
            const key =
              field.fieldType === "default"
                ? this.newObject[field.key]
                : this.newObject.customFields[field.key];
            if (field.controlType === "upload_file" && key) {
              let obj = {
                attachmentName: field.key,
              };
              attachment.push(obj);
              form.append(field.key, key);
            }
          }
          form.append("attachment", JSON.stringify(attachment));
          await uploadDocumentAPI(form);

          this.gobackpointer();
          this.LoaderStatus = false;
          this.$nextTick(() => {
            this.successModal("New Customer has been added.");
          });
        } else if (res.status == 208) {
          this.LoaderStatus = false;
          let errorMessage = res.data.data.Detail;
          this.errorModal(`${errorMessage}`);
        } else if (res.status == 409) {
          this.LoaderStatus = false;
          let errorMessage = res.data.data.Detail;
          this.errorModal(`${errorMessage}`);
        } else {
          this.LoaderStatus = false;
          this.errorModal("Something went wrong");
        }
      } catch (err) {
        this.LoaderStatus = false;
        this.errorModal("Something went wrong!");
        throw err;
      }
    },

    async getCustomer() {
      try {
        const response = await getCustomer({
          type: this.$route.params.type,
          customerID: this.$route.params.customerID,
        });

        const { data } = response.data;
        this.newObject = data;
        this.parentID = this.newObject.customerType == "1" ? 2 : 3;
        this.LoaderStatus = false;
        this.initializeData("edit");
      } catch (err) {
        console.error(err);
        throw err;
      }
    },
    atCustomerChangeType() {
      this.customFieldsArray = [];
      this.newObject = {
        customFields: {},
      };
      this.validation = {};
      this.touchedFields = {};
      this.valText = {};
      if (
        this.$route.name == "EditCustomer" ||
        this.$route.name == "ActivateCustomer"
      ) {
        this.initializeData("edit");
      } else {
        this.initializeData("add");
      }
    },
    async editCustomer() {
      try {
        if (this.$route.name == "ActivateCustomer") {
          this.newObject.active = true;
        }
        this.LoaderStatus = true;
        let anotherCust;
        anotherCust = JSON.parse(JSON.stringify(this.newObject));
        for (const field of this.customFieldsArray) {
          if (field.controlType === "upload_file" && field.isReupload) {
            if (field.fieldType === "default") {
              delete anotherCust[field.key];
            } else {
              delete anotherCust.customFields[field.key];
            }
          }
        }
        let payload = {
          customerType: this.parentID == 2 ? "1" : "2",
          ...anotherCust,
        };

        const res = await putCustomer(payload);
        if (res.status == 200) {
          if (this.$route.name == "ActivateCustomer") {
            this.activatelink = true;
          }
          this.LoaderStatus = false;
          const form = new FormData();
          form.append("type", this.parentID);
          form.append("customerID", this.$route.params.customerID);
          var attachment = [];
          for (const field of this.customFieldsArray) {
            const key =
              field.fieldType === "default"
                ? this.newObject[field.key]
                : this.newObject.customFields[field.key];
            if (
              field.controlType === "upload_file" &&
              field.isReupload &&
              key
            ) {
              let obj = {
                attachmentName: field.key,
              };
              attachment.push(obj);
              form.append(field.key, key);
            }
          }
          form.append("attachment", JSON.stringify(attachment));
          if (attachment.length !== 0) {
            await uploadDocumentAPI(form);
          }
          this.gobackpointer();
          this.$nextTick(() => {
            if (this.activatelink) {
              this.successModal("Customer has been activated.");
            } else {
              this.successModal("Customer has been updated.");
            }
          });
        } else if (res.status == 208) {
          this.LoaderStatus = false;
          let errorMessage = res.data.data.Detail;
          this.errorModal(`${errorMessage}`);
        } else if (res.status == 409) {
          this.LoaderStatus = false;
          let errorMessage = res.data.data.Detail;
          this.errorModal(`${errorMessage}`);
        } else {
          this.LoaderStatus = false;
          this.errorModal("Something went wrong");
        }
      } catch (err) {
        this.LoaderStatus = false;
        this.errorModal("Something went wrong!");
        throw err;
      }
    },

    gobackpointer() {
      this.$router.push({
        name: "Manage",
        query: {
          status: "customer",
          type: this.$route.query.type,
          sort: this.$route.query.sort,
          customerType: this.$route.query.customerType,
        },
      });
    },
  },
};

export default customerData;
